import { num } from "@/lib/format";
import { Card } from "@/components/ui/card";

const LABELS = [
  ["ig_reach", "Account raggiunti"], ["ig_views", "Visualizzazioni"], ["ig_profile_views", "Visite al profilo"],
  ["ig_total_interactions", "Interazioni"], ["ig_accounts_engaged", "Account che hanno interagito"], ["ig_follower_count", "Nuovi follower"],
  ["fb_page_total_media_view_unique", "Persone raggiunte"], ["fb_page_media_view", "Visualizzazioni"], ["fb_page_post_engagements", "Interazioni con i post"],
  ["fb_page_views_total", "Visite alla pagina"], ["fb_page_follows", "Follower della pagina"],
];

const Delta = ({ cur, prev }) => {
  if (!prev) return <span className="text-[11px] text-muted-foreground">nessun dato precedente</span>;
  const d = Math.round(((cur - prev) / prev) * 100);
  return <span className={`text-[11px] ${d >= 0 ? "text-emerald-400" : "text-rose-400"}`}>{d >= 0 ? "+" : ""}{d}% vs periodo prima</span>;
};

export const SocialKpis = ({ kpis, source = "ig" }) => (
  <div className="mb-6 grid grid-cols-2 gap-3 md:grid-cols-4" data-testid="social-kpis">
    {LABELS.filter(([k]) => k.startsWith(`${source}_`) && kpis[k] && (kpis[k].current || kpis[k].previous)).map(([k, l]) => (
      <Card key={k} className="p-4" data-testid={`social-kpi-${k}`}>
        <p className="text-[11px] uppercase tracking-wider text-muted-foreground">{l}</p>
        <p className="font-display text-2xl font-semibold">{num(kpis[k].current)}</p>
        <Delta cur={kpis[k].current} prev={kpis[k].previous} />
      </Card>
    ))}
  </div>
);
